module.exports = __webpack_public_path__ + "img/deliverys.d2c22d31.svg";